// Dependencies
import React, { useEffect, useState } from 'react'
import { PageProps } from 'gatsby'

// Components
import { Layout } from 'components/Layout'
import SimulatorSisu from 'components/simulator'
import { HeroBannerSisu } from 'components/HeroBannerSisu'
import SEO from 'components/seo'
import SisuCarousel from 'components/SisuCarousel'
import PricetableSection from 'components/PriceTableSection'
import { AboutSisu } from 'components/AboutSisu'
import Faq from 'components/Faq'
import { Accordion } from '../components/accordion'
import NeedHelp from '../components/need-help'

export default function Sisu({ location }: PageProps) {
  const [sisuParams, setSisuParams] = useState<any>()

  useEffect(() => {
    if (location.search) {
      getParamsSisu(location.search)
    }
  }, [location])

  const getParamsSisu = (search: string) => {
    const areas = search.slice(1).split('&')

    const formattedNotes = areas.map((areaItem) => {
      let [area, note] = areaItem.split('=')

      const formattedNote = note.includes(',') ? note.replace(',', '.') : note

      return {
        type: area,
        value: parseFloat(formattedNote) ?? 0
      }
    })

    setSisuParams(formattedNotes)
  }

  const faq = {
    title: 'Perguntas Frequentes',
    accordionItems: [
      {
        title: 'Sobre o SiSU',
        content:
          'O Sistema de Seleção Unificada (SiSU) é um programa criado pelo MEC que disponibiliza vagas nas instituições federais e estaduais de Ensino Superior para os participantes do Exame Nacional do Ensino Médio (ENEM).'
      },
      {
        title: 'O que é o Simula SiSU do ProEnem?',
        content: `Desenvolvemos um simulador completo para você simular a sua classificação para a universidade pública. Com o seu resultado do ENEM 2024, você pode usar a nota para simular as suas chances de ingressar na universidade federal.`
      },
      {
        title: 'Como funciona o SiSU?',
        content:
          'Diferentemente dos últimos anos, em que eram realizadas edições semestrais do programa, a partir de 2024, o SiSU acontecerá em edição anual com fase única. As vagas ofertadas nessa edição serão para ingresso nos dois semestres do ano.'
      },
      {
        title: 'Quem pode se inscrever no SiSU?',
        content: `Para se inscrever no SiSU 2025, os candidatos precisam ter realizado a última edição do ENEM, no ano de 2024, e tirar uma nota acima de zero na redação. Os treineiros não podem participar do processo seletivo.`
      },
      {
        title: 'Como funcionam os pesos?',
        content:
          'As universidades estabelecem pesos específicos para cada área de conhecimento da prova do ENEM de acordo com o curso. No geral, os cursos de Exatas como as engenharias possuem maior peso em Matemática e Ciências da Natureza, e os cursos de Humanas possuem maior peso em Linguagens e Humanas. Para saber mais sobre os pesos do seu curso, as instituições disponibilizam o edital no site da instituição.'
      },
      {
        title: 'Como funciona a nota de corte do SiSU?',
        content:
          'Durante o período de inscrição, uma vez por dia, o SiSU calcula automaticamente a nota de corte (que é a menor nota de que o candidato precisa para ficar entre os potencialmente selecionados) para cada curso. Esse cálculo é feito com base no número de vagas disponíveis e no total de candidatos inscritos naquele curso.'
      }
    ]
  }

  return (
    <Layout>
      <SEO
        title="Simulador SiSU 2025"
        description="Com o Simulador SiSU do PROENEM você pode descobrir suas chances de ser aprovado e já começar em 2025 na sua universidade dos sonhos."
      />
      <HeroBannerSisu />
      <SimulatorSisu paramsSisu={sisuParams} />
      <SisuCarousel />
      <PricetableSection />
      <AboutSisu />
      <Faq
        title={faq.title}
        needHelpComposition={
          <NeedHelp
            title="Precisa de ajuda? Fale conosco"
            subtitle="Veja como vamos te ajudar!"
            handleClick={() =>
              window.open(
                'https://api.whatsapp.com/send?phone=5521995481656&text=Me%20ajuda,%20Proenem!',
                '_blank'
              )
            }
          />
        }
        accordionComposition={<Accordion items={faq.accordionItems} />}
      />
    </Layout>
  )
}
